import Cookies from 'js-cookie';

export const checkOnExpiredToken = () => {
  const expiredDate = Cookies.get('expiredAt');

  if (!expiredDate) return true;
  const expiredCurrentDate = new Date(expiredDate);
  return new Date() > expiredCurrentDate;
};
